import React, { useState, useEffect } from 'react';
import { get } from '../../../api';
import Label from '../../auth/components/Label';
import { useSelector } from 'react-redux';
import Big from 'big.js';
import { FormattedMessage } from 'react-intl';
import useSwr from 'swr';
import Dropdown from '../../cmp/Dropdown';
import dayjs from '../../../mydayjs';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';
import DateRangeDropdown, {rangeToDates} from "./components/DateRangeDropdown";
const trafficSorter = (a, b) => {
    return Big(b.visits || 0).cmp(a.visits || 0);
};
const ReferralSources = () => {
    const [limit, setLimit] = useState(5);
    const [selectedRange, setSelectedRange] = useState('thismonth')
    const [start_date, end_date] = rangeToDates[selectedRange];
    const {data, isLoading: loading} = useSwr(`/analytics/traffic_sources?start_date=${start_date}&end_date=${end_date}`, get);
    const traffic = data?.traffic.sort(trafficSorter) || [];
    const totalVisits = data?.total_visits || 0;
    const showFullList = () => {
        setLimit(traffic.length);
    };

    return (
        <div className="card" style={{ width: '100%' }}>
            <div className="card-body">
                <div className="d-flex justify-content-between">
                <Label><FormattedMessage id={"Traffic"} /></Label>
                    <DateRangeDropdown
                        selectedRange={selectedRange}
                        onSelected={setSelectedRange}
                    />
                </div>
                {
                    loading ? <LoadingSkeleton height={63}/> :
                    <div className={"display-4"}>{totalVisits || '-'}</div>
                }
            </div>
            <ul className="list-group list-group-flush">
                {
                    loading ? <LoadingSkeleton height={45} count={5} /> : <>
                {traffic.slice(0, limit).map((item) => {
                    const percent = Number(Big(item.visits || 0).div(totalVisits).times(100).round().toString());
                    return (
                        <li className="list-group-item" key={item.hostname}>
                            <div className="row">
                                <div className={"col"}>{item.hostname}</div>
                                <div className={"col-auto"}>{percent}%</div>
                            </div>
                            <div className={"progress-bar bg-info mt-1"} style={{ height: 3, width: percent + "%" }} />
                        </li>
                    );
                })}</>
                }
            </ul>
            {traffic.length > limit && (
                <div className="text-center">
                    <button className={"btn btn-link"} onClick={showFullList}>
                        <FormattedMessage id={"Show all"} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ReferralSources;
